export const Leaf = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 40 40"
    className={`animate-sway ${className}`}
    style={{ transformOrigin: "50% 100%", transform: flip ? "scaleX(-1)" : undefined }}
    aria-hidden="true"
  >
    <path d="M20 38C8 30 4 16 10 4c14 4 20 18 14 32-1 1-3 2-4 2z" fill="#3A6B4C" opacity="0.55" />
    <path d="M20 36C15 26 13 16 12 8" stroke="#EBF2ED" strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.8" />
  </svg>
);

export const Petal = ({ className = "", delay = 0 }) => (
  <svg viewBox="0 0 20 20" className={`animate-floaty ${className}`} style={{ animationDelay: `${delay}s` }} aria-hidden="true">
    <path d="M10 2C6 5 4 9 6 14c1.5 3.4 6.5 3.4 8 0 2-5 0-9-4-12z" fill="#D86A7A" opacity="0.5" />
  </svg>
);

export const BotanicalOrbit = ({ className = "" }) => (
  <svg viewBox="0 0 300 300" className={`animate-spin-slower ${className}`} aria-hidden="true" fill="none">
    <circle cx="150" cy="150" r="140" stroke="#3A6B4C" strokeOpacity="0.25" strokeDasharray="3 9" strokeWidth="1.5" />
    <circle cx="150" cy="150" r="108" stroke="#D86A7A" strokeOpacity="0.22" strokeDasharray="2 12" strokeWidth="1.5" />
    {[0, 60, 120, 180, 240, 300].map((deg) => (
      <g key={deg} transform={`rotate(${deg} 150 150)`}>
        <path d="M150 6c-5 4-6 10-2 15 4-4 5-11 2-15z" fill="#3A6B4C" fillOpacity="0.35" />
      </g>
    ))}
  </svg>
);

export const DividerCurve = ({ flip = false, fill = "#FAF4EC" }) => (
  <svg
    viewBox="0 0 1440 90"
    preserveAspectRatio="none"
    className={`block w-full h-[50px] sm:h-[70px] ${flip ? "rotate-180" : ""}`}
    aria-hidden="true"
  >
    <path d="M0 60C240 10 480 0 720 30s480 50 720 10v50H0V60z" fill={fill} />
  </svg>
);
